import { FaExclamationTriangle } from "react-icons/fa";

export default function ConfirmModal({
  show,
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false,
  onConfirm,
  onCancel,
}) {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{
        backgroundColor: "rgba(15, 23, 42, 0.6)", // slate overlay
        backdropFilter: "blur(2px)",
      }}
      onClick={onCancel}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="modal-content"
          style={{
            borderRadius: "14px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
          }}
        >
          {/* Header */}
          <div
            className="modal-header border-0 pb-0"
            style={{ justifyContent: "center" }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: "12px",
                background: "#fee2e2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#dc2626",
              }}
            >
              <FaExclamationTriangle size={20} />
            </div>
          </div>

          {/* Body */}
          <div className="modal-body text-center px-4 pt-3 pb-4">
            <h5
              className="fw-semibold mb-2"
              style={{ color: "#0f172a" }}
            >
              {title}
            </h5>
            <p
              className="mb-0"
              style={{
                color: "#64748b",
                lineHeight: "1.6",
              }}
            >
              {message}
            </p>
          </div>

          {/* Footer */}
          <div
            className="modal-footer border-0 pt-0 d-flex justify-content-center gap-2"
          >
            <button
              className="btn"
              onClick={onCancel}
              disabled={loading}
              style={{
                padding: "8px 18px",
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
                background: "white",
                color: "#64748b",
                fontWeight: 500,
              }}
            >
              {cancelText}
            </button>

            <button
              className="btn"
              onClick={onConfirm}
              disabled={loading}
              style={{
                padding: "8px 18px",
                borderRadius: "8px",
                border: "none",
                background: "#dc2626",
                color: "white",
                fontWeight: 500,
                minWidth: 120,
              }}
            >
              {loading ? "Deleting..." : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
